<footer class="text-center text-lg-start bg-dark text-light mt-4 app-footer">
  <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.05);">
    <a class="text-reset fw-bold" href="#">Onelog</a>
  </div>
</footer>
